import { Grid } from '@mui/material';
import { FAQ } from 'config/fe-routes';
import React from 'react';
import { useTranslation } from 'react-i18next';

import config from '../../config';
import A from '../Link/Link';
import PaymentLogos from '../PaymentLogos/PaymentLogos';
import ShippingLogos from '../ShippingLogos/ShippingLogos';

const buyerProtectionFeeEnabled = config.get('buyerProtectionFeeEnabled');

const PaymentsShippingLogos = () => {
  const { t } = useTranslation();

  return (
    <div className="hp_payments_shipping page-wide mt-8">
      <Grid container alignItems="center" className="hp_payments_shipping-grid">
        <div className="hp_payments_shipping-item">
          <div className="hp_payments_shipping-paymentsguarantee">
            <img src="/icons/icn-shield.svg" alt="" className="shield-icon" />
            <p className="hp_payments_shipping-subtext mb-1">
              {t(`components.payment-and-shipping-logos.${buyerProtectionFeeEnabled ? 'safe' : 'guaranteed'}`)}
              <br />
              <A {...FAQ()} className="hp_payments_shipping-link">
                {t('components.payment-and-shipping-logos.how-it-works')}
              </A>
            </p>
          </div>
        </div>
        <div className="hp_payments_shipping-divider"></div>
        <div className="hp_payments_shipping-item hp_payments_shipping-item--payments">
          <p className="hp_payments_shipping-subtext mb-1">{t('components.payment-and-shipping-logos.secure-payments')}</p>
          <PaymentLogos />
        </div>
        <div className="hp_payments_shipping-divider"></div>
        <div className="hp_payments_shipping-item hp_payments_shipping-item--shipping">
          <p className="hp_payments_shipping-subtext mb-1">{t('components.payment-and-shipping-logos.safe-delivery')}</p>
          <ShippingLogos />
        </div>
      </Grid>
    </div>
  );
};

export default PaymentsShippingLogos;
